import TopMenuProfileTop from './TopMenuProfileTop';

export default TopMenuProfileTop;